import React from 'react';
import AddOrEditUserForm from './AddOrEditUserForm';

/* React functional component */
const CreateUserScreen = () => {
  return <AddOrEditUserForm mode="add" />;
};

export default CreateUserScreen;
